import { render, staticRenderFns } from "./Encuentro.vue?vue&type=template&id=83a12118&scoped=true"
import script from "./Encuentro.vue?vue&type=script&lang=js"
export * from "./Encuentro.vue?vue&type=script&lang=js"
import style0 from "./Encuentro.vue?vue&type=style&index=0&id=83a12118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a12118",
  null
  
)

export default component.exports